/* React-Redux */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Axios */
import { AxiosError } from "axios";

/* Utils */
import axiosInterceptor from "src/utils/helper/axios-interceptor";
import { LoginRequestDto } from "src/utils/dto/auth/LoginRequestDto";
import { createCookies } from "src/utils/helper/cookies";

/* Interfaces */
import { AuthProps } from "src/shared/interfaces/common/Auth";
import { ClientError } from "src/utils/status-handling/ClientError";
import { TwoFaLoginRequest } from "src/shared/interfaces/api/Login";
import { GlobalMessageType } from "src/shared/constants/common/GlobalMessage";

export const loginWithOtp = createAsyncThunk<
  AuthProps | undefined,
  TwoFaLoginRequest,
  { rejectValue: ClientError }
>(
  "loginWithOtp",
  async (
    credentials: TwoFaLoginRequest,
    { rejectWithValue }
  ) => {
    try {
      const dto = new LoginRequestDto({
        usernameEmail: credentials.usernameEmail,
        password: credentials.password,
      });

      const requestParams = dto.toApiWithOtp(
        credentials.code
      );

      const response = await axiosInterceptor.post(
        "/login_with_otp",
        requestParams
      );
      return createCookies(response);
    } catch (error) {
      if (error instanceof AxiosError) {
        const { response } = error;
        if (!response) return;

        return rejectWithValue(
          new ClientError({
            type: GlobalMessageType.ERROR,
            statusCode: response.status,
            message: response.data.detail,
          })
        );
      }
      return rejectWithValue(ClientError.unexpected());
    }
  }
);
